import React from 'react';
import * as C from "../componentsM/index";
import myp from '../assets/new-DP-logo-355x358.jpg';

const IBDiploma = () => <>

    <C.Hero title={"INTERNATIONAL BACCALAUREATE DIPLOMA PROGRAMME"} image={"/hero/12.jpg"} />




    <section className='p-4 md:p-24'>

        <div className='flex flex-col gap-5'>


            <p className='font-semibold'>The International Baccalaureate Diploma Programme is a rigourous secondary school course which is designed to inculcate young, motivated people with the IB principles of global citizenship and International Mindedness (illustrated as attributes in the IB Learner Profile) while maintaining and strengthening their own identity.</p>


            <p className='font-semibold'>These principles are embedded in a broad based curriculum which equips our students with the right tools not only to be accepted at colleges and universities across the globe, but also to successfully meet and overcome all challenges that they may face in tomorrow’s world.</p>

            <p className='font-semibold'>Here at The International School, we take pride in the fact that, not only were we the first IB World School in Pakistan, but we are also the first IB World School in the country to offer all three IB Programmes.</p>

            <p className='font-semibold'>In the two years that they spend with us, students (typically from ages 16 – 19) get a comprehensive exposure to a broad based education.  They have the option for pursuing the IB Diploma which requires them to select a combination of six subjects from as many subject groups, along with completing the three components of the Core Programme (Extended Essay, Theory of Knowledge and Creativity, Activity & Service).  Candidates, who do not wish to follow the Diploma path, may register to be IB Diploma Course candidates.  The Core Programme is optional for such candidates.  They also have a choice as to the number of subjects they may study.</p>

        </div>


        <figure className="mx-auto w-1/2"><img src={myp} className="w-full
         object-contain h-[404px]" /></figure>

    </section>




</>

export default IBDiploma